import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import Readonly from '../Readonly';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

interface IProps extends ICellProps {
  onChange: (value: any) => void;
  connection?: {
    config: any;
    list: any[];
  };
  dataAttrQA: { [key: string]: string | number};
}

interface IState {
  filterText?: string;
  elemsVisible?: boolean;
  selectedItems: any[];
}

const TextInput = styled.input`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  padding: 0 25px 0 10px;
`;

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  position: relative;
  i {
    position: absolute;
    right: 15px;
  }
`;

const ElemList = styled.div`
  left: 0;
  top: 38px;
  width: 100%;
  max-height: 300px;
  z-index: 100;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 0px;
  outline: transparent;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(234, 234, 234);
  overflow-x: hidden;
  background-color: #fff;
  ul {
    list-style: none;
    text-align: left;
    margin: 0;
  }
`;

const EmptyText = styled.div`
  padding: 5px 0;
`;

const FilterElement = styled.li`
  position: relative;
  box-sizing: border-box;
  text-align: left;
  cursor: pointer;
  vertical-align: top;
  padding: 4px 10px;
  margin: 0;
  height: auto;
  color: rgb(51, 51, 51);
  width: 100%;
  min-height: 32px;
  line-height: 20px;
  overflow-wrap: break-word;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  &:hover {
    background: #f3f2f1;
  }
`;

// background-color: rgb(218, 218, 218);

class Connection extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }
  public state: IState = {
    selectedItems: this.props.value ?? [],
  }

  componentWillMount() {
    this.setState({ filterText: this.currentValue() });
  }

  componentDidUpdate(prevProps: IProps) {
    if (
      prevProps.value !== this.props.value ||
      prevProps.connection !== this.props.connection
    ) {
      this.setState({ filterText: this.currentValue() });
    }
  }

  currentValue = (): string => {
    const { connection, value } = this.props;
    const config = (connection || { config: { index: null } }).config;
    const list = (connection && connection.list) || [];
    const elem = list.find((el: any) => el[config.index] == value);
    if (elem) {
      return config.format?.(elem);
    }
    return '';
  };

  onFilterChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({ filterText: e.target.value, elemsVisible: true });
  };

  onShowElements = () => {
    this.setState({ elemsVisible: true });
  };

  onHideElements = () => {
    setTimeout(() => {
      if (this.state.elemsVisible) {
        const list = this.getFilteredList();
        let elem = null;
        const { connection, value } = this.props;
        const config = (connection || { config: { index: null } }).config;
        if (this.state.filterText !== '') {
          if (list.length === 1) {
            elem = list[0];
          } else if (list.length > 1) {
            elem = list.find((el: any) => el[config.index] == value);
          }
        }

        if ((elem && elem[config.index]) != value)
          this.props.onChange &&
            this.props.onChange(elem && elem[config.index]);
        else this.setState({ filterText: this.currentValue() });
        this.setState({ elemsVisible: false });
      }
    }, 500);
  };

  onSelectElem = (elem: any) => {
    const { connection } = this.props;
    const config = (connection || { config: { index: null } }).config;
    this.props.onChange && this.props.onChange(elem[config.index]);
    this.setState({ elemsVisible: false });
  };

  getFilteredList = () => {
    const { connection } = this.props;
    const config = (connection || { config: { index: null } }).config;
    const { filterText } = this.state;
    const lower = ((filterText || '') + '').toLowerCase();
    if (lower.length > 0) {
      return ((connection && connection.list) || []).filter((el: any) => {
        return (config.format(el) + '').toLowerCase().indexOf(lower) >= 0;
      });
    }
    return (connection && connection.list) || [];
  };

  render() {
    const { readonly, dataAttrQA } = this.props;
    const { filterText, elemsVisible } = this.state;

    const list = elemsVisible && this.getFilteredList();

    const { connection } = this.props;
    const config = (connection || { config: { index: null } }).config;

    return readonly ? (
      <Readonly {...dataAttrQA}>{filterText}</Readonly>
    ) : config?.autocomplete ? (
      <DataBlock>
        <TextInput
          {...dataAttrQA}
          value={filterText}
          onChange={this.onFilterChange}
          onFocus={this.onShowElements}
          onBlur={this.onHideElements}
        />
        <Icon iconName={'ChevronDown'} />
        {elemsVisible && (
          <ElemList>
            {(list || []).length > 0 ? (
              <ul>
                {(list || []).map((el: any) => (
                  <FilterElement onClick={() => this.onSelectElem(el)}>
                    {config.format(el)}
                  </FilterElement>
                ))}
              </ul>
            ) : (
              <EmptyText>Ничего не найдено</EmptyText>
            )}
          </ElemList>
        )}
      </DataBlock>
    ) : !config?.multipleSelection ? (
      <Dropdown
        options={(
          (connection && connection.list && [null, ...connection.list]) ||
          []
        ).map((el: any) => {
          return el
            ? {
                key: el[config.index] + '',
                text: config.format(el),
              }
            : { key: '', text: '' };
        })}
        styles={{
          title: {
            border: 'none',
            textAlign: 'left',
          },
        }}
        selectedKey={this.props.value ? this.props.value + '' : null}
        onChange={(
          event: React.FormEvent<HTMLDivElement>,
          item?: IDropdownOption,
          index?: number | undefined
        ) => this.props.onChange && this.props.onChange(item!.key as string)}
      />
    ) : (
      <Dropdown
        options={(
          (connection && connection.list && [null, ...connection.list]) ||
          []
        ).map((el: any) => {
          return el
            ? {
                key: el[config.index],
                text: config.format(el),
              }
            : { key: '', text: '' };
        })}
        styles={{
          title: {
            border: 'none',
            textAlign: 'left',
          },
        }}
        selectedKeys={this.props.value}
        onChange={(
          event: React.FormEvent<HTMLDivElement>,
          item?: IDropdownOption,
          index?: number | undefined
        ) => {
          const newSelectedItems = [...this.state.selectedItems];
          if (item?.selected) {
            newSelectedItems.push(item.key);
          } else {
            const currIndex = newSelectedItems.indexOf(item?.key as string);
            if (currIndex > -1) {
              newSelectedItems.splice(currIndex, 1);
            }
          }
          this.setState({
            selectedItems: newSelectedItems
          });
          this.props.onChange && this.props.onChange(newSelectedItems)
        }}
        multiSelect
      />
    )
    ;
  }
}

export default Connection;
